import React from "react";
import "./CourseHighlights.css";
import icon1 from "../../../../assets/icons/cou1.svg";
import icon2 from "../../../../assets/icons/cou2.svg";
import icon3 from "../../../../assets/icons/cou3.svg";
import icon4 from "../../../../assets/icons/cou4.svg";

const items = [
  { id: "certified", icon: icon1, label: "IRQGYP certified" },
  { id: "recognized", icon: icon2, label: "Recognized in Iraq & region" },
  { id: "results", icon: icon3, label: "Professional results" },
  { id: "employment", icon: icon4, label: "Employment guarantee" },
];

const CourseHighlights = () => {
  return (
    <section className="courseHighlights" aria-label="Course highlights">
      <div className="courseHighlights-inner">
        <p className="courseHighlights-title">Integrated Systems for <br /> Every Construction Need</p>
        <div className="courseHighlights-grid">
          {items.map((item) => {
            return (
              <div className="courseHighlights-item" key={item.id}>
                <img src={item.icon} alt="" aria-hidden />
                <span>{item.label}</span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CourseHighlights;
